import * as React from "react";
import Component from "../../AbstractComponent";
import PropertySummary from "./PropertySummary";
import PropertyDetailsEditable from "./PropertyDetailsEditable";
import PropertyDetailsReadonly from "./PropertyDetailsReadonly";

import {
	Card
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class PropertyCard extends Component {
	public state = {
		isSummaryView: true
	};

  constructor(public props) {
    super(props);

		let isSummaryView = true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		const isReadonly = this.props.property?.isReadonly ||
											 this.props.isReadonly;

		if ((this.props.mainCardPresentation && isReadonly) || this.props.openedByDefault) {
			isSummaryView = false;
		}

		this.state.isSummaryView = isSummaryView;
	}

	public changeView = (): void => {
		if (typeof this.props.propertyIdForDetailsPresentation !== "undefined") {
			if (this.props.propertyIdForDetailsPresentation === this.props.property?.id) {
				this.props.changePropertyIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changePropertyIdForDetailsPresentation.call(this, this.props.property?.id);
			} 
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}
	
  public render() {
		const isReadonly = this.props.property?.isReadonly ||
											 this.props.isReadonly;
		const isSummaryView = typeof this.props.propertyIdForDetailsPresentation !== "undefined" ?
														this.props.propertyIdForDetailsPresentation !== this.props.property?.id :
														this.state.isSummaryView;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "40px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					{
						isSummaryView && <PropertySummary {...this.props}/>
					}

					{
						!isSummaryView && (isReadonly || !this.props.mainCardPresentation) && <PropertyDetailsReadonly {...this.props} />
					}

					{
						!isSummaryView && !isReadonly && this.props.mainCardPresentation && <PropertyDetailsEditable {...this.props} />
					}
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
